module.exports = __webpack_public_path__ + "static/media/regular-marker.47b79cdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/regular-marker.svg
// module id = 876
// module chunks = 0